'use client';
import TxProcessingModal from '@/src/components/AppComponents/TxProcessingModal/TxProcessingModal';
import TxUserConfirmationModal from '@/src/components/AppComponents/TxUserConfirmationModal/TxUserConfirmationModal';
import { Button } from '@/src/components/Commons/Button';
import ToggleProController from '@/src/components/Commons/Controllers/ToggleProController/ToggleProController';
import TogleViewListOrDetailsController from '@/src/components/Commons/Controllers/TogleViewListOrDetailsController/TogleViewListOrDetailsController';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { useDetails } from '@/src/hooks/useDetails';
import { IFundDetailsForUsers } from '@/src/hooks/useFundDetailsForHome';
import { IFundListForUsers } from '@/src/hooks/useFundListForHome';
import useWindowSize from '@/src/hooks/useResponsive';
import { useTransactions } from '@/src/hooks/useTransactions';
import {
    createToken_Gov_With_Amount,
    DelegationApi,
    DelegationBtnHandlers,
    DelegationCreateTxParams,
    DelegationDepositTxParams,
    DelegationEntity,
    DelegationTxApiCalls,
    DelegationWithdrawTxParams,
    LookUpFields,
    LucidToolsFrontEnd,
    SmartUTxOEntity,
} from '@/src/lib/MayzSmartDB';
import { useWalletStore } from '@/src/store';
import { hexToStr, isNullOrBlank } from '@/src/lib/MayzSmartDB';
import { ARROW_DOWN_UP } from "@/src/lib/SmartDB/Commons/Constants/images";
import { ROUTES } from '@/src/utils/routes';
import { useRouter } from '@/src/store/router/RouterProvider';
import { useEffect, useState } from 'react';
import styles from './Delegate.module.scss';
import DelegationStatus from './Form/ControlsPro/DelegationStatus';
import DelegateForm from './Form/DelegateForm';
import { TASK, TOKEN_GOV_TN_STR } from '@/src/utils/constants';

type DelegateProps = { isAddingTokens: boolean };

export default function Delegate(props: DelegateProps & IFundDetailsForUsers & IFundListForUsers) {
    //--------------------------------------
    const { id, fund, refreshDetails, isLoadedDetails, isRefreshing, isLoadingDetails, protocol, isTokensStoreReady, isLoadingList, list, refreshList, isAddingTokens } = props;
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const walletStore = useWalletStore();
    //--------------------------------------
    const { width } = useWindowSize();
    const isTablet = width <= 768;
    const isMobile = width <= 480;
    //--------------------------------------
    const [isDeposit, setIsDeposit] = useState<boolean>(true);
    //--------------------------------------
    const [isValidInput_TokenGov, setIsValidInput_TokenGov] = useState<boolean>(true);
    //--------------------------------------
    const [input_TokenGov, setInput_TokenGov] = useState(0n);
    //--------------------------------------
    const [available_TokenGov_in_Delegation, setAvailable_TokenGov_in_Delegation] = useState(0n);
    const [isMaxAmountLoaded, setIsMaxAmountLoaded] = useState(false);
    //--------------------------------------
    const { delegation_id, task } = router.query;
    //--------------------------------------
    const allowedTasks = ['deposit', 'withdraw'];
    //--------------------------------------
    const isAllowedTask = (task: string): boolean => {
        return allowedTasks.includes(task);
    };
    //--------------------------------------
    const loadDelegation = async (new_id?: string) => {
        //-----------
        if (fund === undefined) return;
        if (walletStore.isWalletDataLoaded !== true) return;
        //-----------
        console.log(`DEBUG - loadDelegation - fund: ${fund._DB_id}`);
        //-----------
        setIsMaxAmountLoaded(false);
        //-----------
        const paramsBase: Record<string, any> = {
            ddDelegatorPaymentPKH: walletStore.info!.pkh,
            ddFundPolicy_CS: fund.getNET_id_CS(),
            'smartUTxO.isPreparingForReading': { $exists: false },
            'smartUTxO.isReading': { $exists: false },
            'smartUTxO.isPreparingForConsuming': { $exists: false },
            'smartUTxO.isConsuming': { $exists: false },
        };
        const arrayAndQueryId = [paramsBase];
        //--------
        if (!isNullOrBlank(delegation_id as string)) {
            const params = { _id: delegation_id as string };
            arrayAndQueryId.push(params);
        }
        //--------
        const lookUpFields: LookUpFields[] = [
            {
                from: SmartUTxOEntity.className(),
                localField: 'smartUTxO_id',
                foreignField: '_id',
                as: 'smartUTxO',
                fieldsForSelect: { isPreparingForReading: true, isReading: true, isPreparingForConsuming: true, isConsuming: true },
            },
        ];
        //--------
        const params: Record<string, any> = { $and: arrayAndQueryId };
        //--------
        let delegation: DelegationEntity | undefined = await DelegationApi.getOneByParamsApi_(params, { lookUpFields, sort: { ddStaked: -1 } });
        //--------------------------------------
        if (delegation === undefined) {
            delegation = await DelegationApi.getOneByParamsApi_(paramsBase, { sort: { ddStaked: -1 } });
        }
        //--------------------------------------
        //TODO: ver delegaciones, como hago si hay mas de una por fondo? deberia impedir eso, y ahcer que los depositos hagan updates de la ya existente
        // y si por casualidad fuera amsd e una aca muestro una sola, la con mas tokens
        setAvailable_TokenGov_in_Delegation(delegation?.ddStaked ?? 0n);
        //-----------
        setIsMaxAmountLoaded(true);
        //-----------
        if (delegation === undefined) {
            setIsDeposit(true);
        }
        //--------------------------------------
        return delegation;
    };
    //--------------------------------------
    const {
        isLoadingDetails: isLoadingDelegation,
        isLoadedDetails: isLoadedDelegation,
        current: delegation,
        refreshDetails: refreshDetailsDelegation,
    } = useDetails<DelegationEntity>({
        nameDetails: DelegationEntity.className(),
        loadDetails: loadDelegation,
        dependencies: [props.isLoadedDetails, fund, walletStore.isWalletDataLoaded, delegation_id, router.isReady],
        checkDependencies: () => {
            //--------------------------------------
            let doLoadList = false;
            if (props.isLoadedDetails === true && walletStore.isWalletDataLoaded === true && router.isReady === true) {
                doLoadList = true;
            }
            return doLoadList;
        },
        //--------------------------------------
    });
    //--------------------------------------
    function resetForm() {
        setInput_TokenGov(0n);
    }
    //--------------------------------------
    const onTx = async () => {
        resetForm();
        await props.refreshDetails(fund!._DB_id);
        await props.refreshList();
    };
    const onTryAgainTx = async () => {
        setIsFaildedTx(false);
        setShowProcessingTx(false);
    };
    const onFinishTx = async () => {
        // si la tx paso, ya se reseto el form en onTx, pero por las dudas, si aprienta cuando falla
        if (isFaildedTx === true) {
            resetForm();
        }
        setIsConfirmedTx(false);
        setIsFaildedTx(false);
        setShowProcessingTx(false);
    };
    //--------------------------------------
    async function checkIsValidTx() {
        let isValid =
            props.isLoadedDetails === true &&
            isValidInput_TokenGov === true &&
            isMaxAmountLoaded === true &&
            isMaxAmountLoadedFromTxHook === true &&
            isLoadedDelegation === true &&
            ((isDeposit === false && delegation !== undefined && delegation.smartUTxO?.isAvailableForConsuming() === true) ||
                isDeposit === true);
        if (isDeposit === true) {
            isValid = isValid && input_TokenGov > 0;
        } else {
            isValid = isValid && input_TokenGov > 0;
        }
        return isValid;
    }
    //--------------------------------------
    const dependenciesValidTx: any[] = [isValidInput_TokenGov, input_TokenGov, isDeposit, props.isLoadedDetails, isMaxAmountLoaded, delegation, isLoadedDelegation];
    //--------------------------------------
    const {
        appStore,
        tokensStore,
        session,
        status,
        showUserConfirmation,
        setShowUserConfirmation,
        showProcessingTx,
        setShowProcessingTx,
        isProcessingTx,
        setIsProcessingTx,
        isFaildedTx,
        setIsFaildedTx,
        isConfirmedTx,
        setIsConfirmedTx,
        processingTxMessage,
        setProcessingTxMessage,
        processingTxHash,
        setProcessingTxHash,
        isValidTx,
        setIsValidTx,
        tokensGiveWithMetadata,
        setTokensGiveWithMetadata,
        tokensGetWithMetadata,
        setTokensGetWithMetadata,
        available_TokenGov_in_Wallet,
        available_FT_in_Wallet,
        available_ADA_in_Wallet,
        available_forSpend_ADA_in_Wallet,
        isMaxAmountLoaded: isMaxAmountLoadedFromTxHook,
        handleBtnShowUserConfirmation,
        handleBtnDoTransaction_WithErrorControl,
    } = useTransactions({ ...props, dependenciesValidTx, checkIsValidTx, onTx });
    //--------------------------------------
    useEffect(() => {
        if (router.isReady) {
            if (!isNullOrBlank(task as string) && isAllowedTask(task as string) === true) {
                if (task === 'deposit') {
                    setIsDeposit(true);
                } else if (task === 'withdraw' && delegation !== undefined) {
                    setIsDeposit(false);
                }
            }
        }
    }, [task, router.isReady, delegation]);
    //--------------------------------------
    useEffect(() => {
        if (fund !== undefined) {
            resetForm();
        }
    }, [fund]);
    //--------------------------------------
    useEffect(() => {
        if (showUserConfirmation === true && fund !== undefined) {
            if (isDeposit === true) {
                const tokensToGive = [createToken_Gov_With_Amount(input_TokenGov)];
                setTokensGiveWithMetadata(tokensToGive.filter((token) => token && token.amount > 0));
                setTokensGetWithMetadata([]);
            } else {
                setTokensGiveWithMetadata([]);
                const tokensToGet = [createToken_Gov_With_Amount(input_TokenGov)];
                setTokensGetWithMetadata(tokensToGet.filter((token) => token && token.amount > 0));
            }
        }
    }, [showUserConfirmation, isDeposit, input_TokenGov]);
    //--------------------------------------
    const handleClickToggleDepositWithdraw = () => {
        if (isDeposit === true && delegation !== undefined && available_TokenGov_in_Delegation > 0n) {
            setIsDeposit(false);
            setInput_TokenGov(input_TokenGov);
        } else {
            setIsDeposit(true);
            setInput_TokenGov(input_TokenGov);
        }
    };
    //--------------------------------------
    function handleChange_Input_TokenGov(input_TokenGov: bigint) {
        setInput_TokenGov(input_TokenGov);
    }
    //--------------------------------------
    const handleBtnDepositTx = async () => {
        //--------------------------------------
        setProcessingTxMessage('Preparing...');
        //--------------------------------------
        const fetchParams = async () => {
            //--------------------------------------
            if (protocol === undefined || fund === undefined) {
                throw 'protocol === undefined || fund === undefined || delegation === undefined';
            }
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            let txParams;
            //--------------------------------------
            if (delegation === undefined) {
                txParams = {
                    protocol_id: protocol._DB_id,
                    fund_id: fund._DB_id,
                    stake: input_TokenGov,
                } as DelegationCreateTxParams;
            } else {
                txParams = {
                    protocol_id: protocol._DB_id,
                    fund_id: fund._DB_id,
                    delegation_id: delegation._DB_id,
                    stake: input_TokenGov,
                } as DelegationDepositTxParams;
            }
            return {
                lucid,
                emulatorDB,
                walletTxParams,
                txParams,
            };
        };
        //--------------------------------------
        const txApiCall = DelegationTxApiCalls.callGenericTxApi.bind(DelegationTxApiCalls);
        const handleBtnTx = DelegationBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind(DelegationBtnHandlers);
        //--------------------------------------
        if (delegation === undefined) {
            await handleBtnDoTransaction_WithErrorControl(DelegationEntity, 'Stake Tx', 'Staking...', 'create', fetchParams, txApiCall, handleBtnTx);
        } else {
            await handleBtnDoTransaction_WithErrorControl(DelegationEntity, 'Stake Tx', 'Staking...', 'deposit', fetchParams, txApiCall, handleBtnTx);
        }
        //--------------------------------------
    };
    const handleBtnWithdrawTx = async () => {
        //--------------------------------------
        setProcessingTxMessage('Preparing...');
        //--------------------------------------
        const fetchParams = async () => {
            //--------------------------------------
            if (protocol === undefined || fund === undefined || delegation === undefined) {
                throw 'protocol === undefined || fund === undefined || delegation === undefined';
            }
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const txParams: DelegationWithdrawTxParams = {
                protocol_id: protocol._DB_id,
                fund_id: fund._DB_id,
                delegation_id: delegation._DB_id,
                unstake: input_TokenGov,
            };
            return {
                lucid,
                emulatorDB,
                walletTxParams,
                txParams,
            };
        };
        //--------------------------------------
        const txApiCall = DelegationTxApiCalls.callGenericTxApi.bind(DelegationTxApiCalls);
        const handleBtnTx = DelegationBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind(DelegationBtnHandlers);
        //--------------------------------------
        if (delegation !== undefined && delegation.ddStaked === input_TokenGov) {
            await handleBtnDoTransaction_WithErrorControl(DelegationEntity, 'Unstake Tx', 'Unstaking...', 'delete', fetchParams, txApiCall, handleBtnTx);
        } else {
            await handleBtnDoTransaction_WithErrorControl(DelegationEntity, 'Unstake Tx', 'Unstaking...', 'withdraw', fetchParams, txApiCall, handleBtnTx);
        }
        //--------------------------------------
    };
    const handleBtnDepositOrWithdrawTx = async () => {
        if (isDeposit === true) {
            await handleBtnDepositTx();
        } else {
            await handleBtnWithdrawTx();
        }
    };
    //--------------------------------------

    //--------------------------------------
    return (
        <>
            {(props.isLoadedDetails === true && fund !== undefined && protocol !== undefined) ||
            (props.isLoadingDetails === true && fund !== undefined && fund._DB_id === id && protocol !== undefined) ? (
                <main className={styles.delegateSection}>
                    <div className={styles.header}>
                        <div className={styles.fundSelector}>
                            <h2 className={styles.fundTitle}>{isDeposit ? `STAKE ${TOKEN_GOV_TN_STR}` : `UNSTAKE ${TOKEN_GOV_TN_STR}`}</h2>
                            {props.isLoadingDetails === true && <LoaderButton />}
                        </div>
                        <div className={styles.toggleGroup}>
                            {isLoadingDelegation === false && isLoadedDelegation === true && delegation !== undefined && available_TokenGov_in_Delegation > 0n && (
                                <div className={styles.inputControllerSwitch}>
                                    <div className={styles.switch} onClick={() => handleClickToggleDepositWithdraw()}>
                                        <svg width="16" height="16" id="icon" className={`${styles.iconSwicht} ${!isDeposit ? styles.isSell : ''}`}>
                                            <use href={ARROW_DOWN_UP}></use>
                                        </svg>
                                    </div>
                                </div>
                            )}
                            <TogleViewListOrDetailsController {...props} />
                            <ToggleProController />
                        </div>
                    </div>
                    <DelegateForm
                        protocol={protocol}
                        fund={fund}
                        isDeposit={isDeposit}
                        isTokensStoreReady={isTokensStoreReady}
                        isAddingTokens={isAddingTokens}
                        isLoadingDelegation={isLoadingDelegation}
                        isLoadedDelegation={isLoadedDelegation}
                        delegation={delegation}
                        isValidInput_TokenGov={isValidInput_TokenGov}
                        setIsValidInput_TokenGov={setIsValidInput_TokenGov}
                        input_TokenGov={input_TokenGov}
                        isValidTx={isValidTx}
                        isProcessingTx={isProcessingTx}
                        setShowProcessingTx={setShowProcessingTx}
                        setShowUserConfirmation={setShowUserConfirmation}
                        available_TokenGov_in_Wallet={available_TokenGov_in_Wallet}
                        available_TokenGov_in_Delegation={available_TokenGov_in_Delegation}
                        handleChange_Input_TokenGov={handleChange_Input_TokenGov}
                        handleClickToggleDepositWithdraw={handleClickToggleDepositWithdraw}
                    />
                </main>
            ) : (
                <div className={styles.delegateSectionLoading}>
                    <div className={styles.controller}>
                        <div className={styles.headerController}>
                            <h2 className={styles.titleController}>{isDeposit ? `STAKE...` : `UNSTAKE...`}</h2>
                            {/* <div className={styles.toggleController}>
                                <p className={`${styles.text} ${styles.active}`}>Delegate</p>
                                <div className={styles.toggle}>
                                    <span className={`${styles.point} ${styles.active}`}></span>
                                </div>
                                <p className={styles.text}>Withdraw</p>
                            </div> */}
                        </div>
                        <div className={styles.bodyController}>
                            <div className={styles.rowLoader}></div>
                            <div className={styles.confirmationSection}>LOADING...</div>
                        </div>
                    </div>
                </div>
            )}
            {showUserConfirmation && walletStore.isConnected === true && fund !== undefined && (
                <>
                    <TxUserConfirmationModal
                        title={isDeposit ? `STAKE IN ${fund.name} [${hexToStr(fund.fdFundFT_TN_Hex)}]` : `UNSTAKE FROM ${fund.name} [${hexToStr(fund.fdFundFT_TN_Hex)}]`}
                        protocol={protocol}
                        fund={fund}
                        isValidTx={isValidTx}
                        btnTxInvalidName={'Invalid Tx please try again'}
                        tokensGive={tokensGiveWithMetadata}
                        tokensGet={tokensGetWithMetadata}
                        showExtraInfo={walletStore.swProInterface === true}
                        extraInfo={
                            walletStore.swProInterface === true &&
                            fund !== undefined &&
                            protocol !== undefined && (
                                <DelegationStatus
                                    fund={fund}
                                    isDeposit={isDeposit}
                                    isLoadingDelegation={isLoadingDelegation}
                                    isLoadedDelegation={isLoadedDelegation}
                                    isTokensStoreReady={isTokensStoreReady}
                                    delegation={delegation}
                                    protocol={protocol}
                                    input_TokenGov={input_TokenGov}
                                    classNameStyle="darker"
                                />
                            )
                        }
                        onConfirm={async () => handleBtnDepositOrWithdrawTx()}
                        onCancel={async () => setShowUserConfirmation(false)}
                    />
                </>
            )}

            <TxProcessingModal
                showProcessingTx={showProcessingTx}
                setShowProcessingTx={setShowProcessingTx}
                isProcessingTx={isProcessingTx}
                processingTxMessage={processingTxMessage}
                processingTxHash={processingTxHash}
                isFaildedTx={isFaildedTx}
                isConfirmedTx={isConfirmedTx}
                onTryAgainTx={onTryAgainTx}
                onFinishTx={onFinishTx}
                showNewTransactionButton={false}
                showViewTransactionsButton={false}
                showTryAgainTransactionButton={true}
                othersButtonsWhenConfirmed={
                    <>
                        <Button
                            mode="outline"
                            width={'100%'}
                            onClick={async () => {
                                setShowProcessingTx(false);
                                await router.push({
                                    pathname: ROUTES.PORTFOLIO,
                                });
                            }}
                        >
                            View Portfolio
                        </Button>
                    </>
                }
            />
        </>
    );
}
